import React from 'react';
import { PropsWithChildren, createContext, useContext, useState } from "react";
import { AppContext } from "Context/AppContext";
import { useNavigate } from "react-router";
import { EMPTY_PIVOT_ELEMENT, Invalid_Array, OPERATORS } from '../constants/CSConstants';
import { fetchAttributes, getPivotData, getPivotListByCategoryId, savePivotData, updatePivotData, } from '../services/CSServices';
import { getCategoryList } from 'Components/GMS/CatalogManagement/service';
import { toast } from 'Components/DesignSystem/Toast/useToast';
import { getObjectByProperty, isString } from '../utils/CSHelper';
import { TResponseData } from 'Services/types';


export const CSContext = createContext<any>(undefined);

export const CSContextProvider = ({ children }: PropsWithChildren) => {
    const appContext = useContext(AppContext);
    const industryId = appContext.get_selected_industry() && appContext?.get_selected_industry()?.id;
    const channel_key = appContext?.channelKey
    const navigate = useNavigate();
    const [pivotData, setPivotData] = useState<UpdatePivotType>()
    const [pivotList, setPivotList] = useState<pivotListType[]>([
        EMPTY_PIVOT_ELEMENT
    ]);
    const [categoryList, setCategoryList] = useState<any>([]);
    const [attributeList, setAttributeList] = useState<any>([]);
    const [category, setCategory] = useState<string>();
    const [loading, setLoading] = useState(false);
    const [pivotDataloading, setPivotDataloading] = useState(false);
    const [pivotVersionList, setPivotVersionList] = useState<any[]>([]);
    const [versionName, setVersionName] = useState<string>("");
    // const [linkData, setLinkData] = useState<{ category_id: string, version_name: string, uid: string, category_name: string }>()
    const [newlyCreatedId, setNewlyCreatedId] = useState<string | null>(null);


    const fetchPivotData = async (uid: string) => {
        try {
            let ret = await getPivotData(uid)
            if (!ret.errorfound) {
                if (ret && ret?.body) {
                    const pivots = JSON.parse(ret?.body)
                    setPivotList(pivots);
                    setPivotData(ret)
                    setVersionName(ret?.version_name)
                } else resetPivote();
            }
        } catch (error) {
            console.log("ERROR", error)
        }
        finally {
            setLoading(false)
        }
    };


    const handlePivotData = (data: UpdatePivotType) => {
        const pivots = JSON.parse(data?.body as string)
        setPivotList(pivots);
        setPivotData(data)
        setVersionName(data?.version_name as string)
    }


    const resetPivote = () => {
        setPivotList([
            {
                pivot_attribute: "",
                operator: OPERATORS[0]?.value,
                base_attribute: "",
                weightage: "",
                pivot_attribute_name: "",
                base_attribute_name: "",
            },
        ]);
    };

    const getPivotVersions = async (categoryId: string,
        updateTotalRecords: (total: number) => void = (total: number) => { },
        paginationParams: { page: number, per_page: number } =
            { page: 1, per_page: 10 }) => {
        try {
            setPivotDataloading(true)
            const res = await getPivotListByCategoryId(
                paginationParams?.page,
                paginationParams?.per_page,
                industryId as string,
                channel_key,
                categoryId)
            if (res?.pivot_attributes) {
                setPivotVersionList(res?.pivot_attributes)
                updateTotalRecords(res?.total)
                if (res?.pivot_attributes?.length === 0) toast.info("No versions found for this category")
                setPivotDataloading(false)

            }
        } catch (error) {
            console.error("CSContextProvider ~ error:", error)
        }
        finally {
            setPivotDataloading(false)
        }
    }
    const handleCategoryChange = (e: string, updateTotal: (total: number) => void) => {
        resetState();
        setCategory(e);
        getAttributes(e);
        getPivotVersions(e, updateTotal);
    };

    const fetchInitialState = async (categoryId: string, uid: string) => {
        try {
            setLoading(true);
            await getGMSCategories();
            if (!Invalid_Array.includes(categoryId) && !Invalid_Array.includes(uid)) {
                setCategory(categoryId);
                await getAttributes(categoryId);
                if (uid)
                    await fetchPivotData(uid);
            }
        } catch (error) {
            console.log("ERROR", error)
        }
        finally {
            setLoading(false)
        }
    };

    const getGMSCategories = async () => {
        const response = await getCategoryList(industryId);
        if (response) {
            const sortedData = response.sort((a: any, b: any) => {
                return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
            });
            const option = sortedData?.map((x: any) => {
                return {
                    label: x?.name,
                    value: x?.id,
                };
            });
            setCategoryList(option);
        } else return [];
    };

    const handleRowDelete = (index: number) => {
        setPivotList((prev) => {
            let localPrev = [...prev];
            if (index >= 0 && index < prev?.length) {
                localPrev.splice(index, 1);
                return localPrev;
            }
            return prev;
        });
    };

    const handleAdd = (index: number) => {
        const sum = getWeightageSum()
        if (sum < 100) {
            setPivotList((prev) => {
                const prePivot = prev[index];
                if (
                    prePivot?.base_attribute &&
                    prePivot?.pivot_attribute &&
                    prePivot?.operator &&
                    prePivot?.weightage
                ) {
                    return [
                        ...prev,
                        {
                            pivot_attribute: "",
                            operator: OPERATORS[0]?.value,
                            base_attribute: "",
                            weightage: "",
                            pivot_attribute_name: "",
                            base_attribute_name: "",
                        },
                    ];
                }
                return prev;
            });
        }
    };


    const handlePivotListChange = (e: any, index: number, type: string) => {
        if ((pivotList?.filter(x => x?.pivot_attribute === e))?.length > 0) return toast.info("Attribute already selected")
        let property: keyof PivotType;
        let propertyName: keyof PivotType;
        switch (type) {
            case "pivot":
                property = "pivot_attribute";
                propertyName = "pivot_attribute_name";
                break;
            case "base":
                property = "base_attribute";
                propertyName = "base_attribute_name";
                break;
            case "operator":
                property = "operator";
                break;
            case "weight":
                property = "weightage";
                e.persist();
                break;
            default:
                break;
        }
        setPivotList((prev) => {
            const localList = [...prev];
            localList[index][property] = type === "weight" ? e?.target?.value : e;
            if (type === "pivot") {
                localList[index]["pivot_attribute"] = e;
                localList[index]["base_attribute"] = e;
                const name = getObjectByProperty(attributeList, "value", e);
                localList[index]["pivot_attribute_name"] = name;
                localList[index]["base_attribute_name"] = name;
            }
            if (type == "base")
                localList[index][propertyName] = getObjectByProperty(
                    attributeList,
                    "value",
                    e
                );
            return localList;
        });
    };

    const handleDone = async (uid: string, mode: string = "edit") => {
        const sum = getWeightageSum()
        if (sum === 100) {
            if (versionName == "" || Invalid_Array.includes(versionName)) return toast.info("version name is mandatory")
            let res: string | TResponseData
            switch (mode) {
                case "edit_version":
                    res = await updatePivotData({ ...pivotData, version_name: versionName, body: pivotList, is_version: true })
                    break;
                case "create_version":
                    res = await savePivotData({ version_name: versionName, body: pivotList, is_version: true, category_id: category as string, channel_key: channel_key ?? "K7pLWANJH2Yk3OYuJFka" })
                    break;
                case "edit":
                    res = await updatePivotData({ ...pivotData, version_name: versionName, body: pivotList, is_version: false })
                    break;
                default:
                    res = await savePivotData({ version_name: versionName, body: pivotList, is_version: false, category_id: category as string, channel_key: channel_key ?? "K7pLWANJH2Yk3OYuJFka" })
                    break;
            }
            if (!isString(res)) {
                const data = (res as TResponseData)?.data

                if (data?.done) {
                    if (['create', 'create_version'].includes(mode)) {
                        toast.success("Saved Successfully");
                        setNewlyCreatedId(data?.data?.uid)
                    }
                    else toast.success("Updated Successfully");
                    resetState();
                    navigate("/gms/substitutions/");
                } else {
                    if (data?.data) {
                        /*
                          § 116. This was a `<p>` containing a `<Link>`, handed to
                          react-toastify as JSX. The DS toast has a first-class
                          `action` slot, which is the honest home for it: the link
                          becomes a real button rather than an `<a>` buried in a
                          notification, and it dismisses the toast when used.

                          Option mapping: `autoClose: false` -> `duration: null`.
                          `closeOnClick` has no equivalent and is dropped — the toast
                          has its own dismiss control. So is
                          `className: 'tw-mt-[120px]'`, a hand-set offset that pushed
                          the toast clear of the old container's position;
                          `ToastRegion` places itself.
                        */
                        toast.info('Identical version exists', {
                            description: `${data?.data?.category_name} ${data?.data?.version_name}`,
                            duration: null,
                            action: {
                                label: 'Open it',
                                onClick: () => navigate(
                                    `/gms/substitutions/edit/${data?.data?.category_id}/${data?.data?.uid}`
                                ),
                            },
                        });
                    }
                    else toast.info(data?.message ?? 'Could not save the version');
                }
            } else toast.info(res as string);
        } else toast.info("Total Weightage must be equal to 100");
    };

    const resetState = () => {
        setPivotList([
            {
                pivot_attribute: "",
                operator: OPERATORS[0]?.value,
                base_attribute: "",
                weightage: "",
                pivot_attribute_name: "",
                base_attribute_name: "",
            },
        ]);
        setCategory("");
        setPivotVersionList([])
        setVersionName("")
    };

    async function getAttributes(categoryId: string) {
        let res = await fetchAttributes(categoryId)
        if (res) {
            const sortedData = res?.sort((a: any, b: any) => {
                return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
            });
            const optionList = sortedData?.map((x: any) => {
                return {
                    label: x?.name,
                    value: x?.id,
                    dataType: x?.datatype
                };
            });
            setAttributeList(optionList);
        }
    }

    const getWeightageSum = () => {
        return pivotList?.reduce(
            (sum, obj) => sum + parseFloat(obj.weightage || "0"),
            0
        );
    };

    const getAttributeDataType = (id: string) => {
        const res = attributeList?.find((x: { label: string, value: string, dataType: string }) => x.value === id)
        return res?.dataType
    }

    return (
        <CSContext.Provider value={
            {
                pivotList,
                pivotData,
                setPivotList,
                categoryList,
                setCategoryList,
                attributeList,
                setAttributeList,
                category,
                setCategory,
                loading,
                setLoading,
                fetchPivotData,
                savePivotData,
                getAttributeDataType,
                getWeightageSum,
                getAttributes,
                getCategoryList,
                resetState,
                handleDone,
                handlePivotListChange,
                handleAdd,
                handleRowDelete,
                fetchInitialState,
                handleCategoryChange,
                resetPivote,
                pivotVersionList,
                setPivotVersionList,
                versionName,
                setVersionName,
                handlePivotData,
                pivotDataloading,
                setPivotDataloading,
                getPivotVersions,
                newlyCreatedId,
            }}>
            {children}
        </CSContext.Provider>
    );
}